import type { Letters } from '@/domain/scoring';

export const TUTORIAL_LETTERS: Letters = ['к', 'о', 'т'] as const;
